export default "__VITE_ASSET__vlMsf6jd__"